// extracted by mini-css-extract-plugin
export default {"wrapper":"D1-z","play":"E1-z"};